import { LoaderCircle } from "lucide-react";
import { ProgressBar } from "@/shared/components/ui/progress-bar";

export function ExportProgressToast({
  current,
  total,
}: {
  current: number;
  total: number;
}) {
  const pct = total > 0 ? Math.round((current / total) * 100) : 0;
  const isSingle = total === 1;

  return (
    <div className="w-[356px] rounded-lg border border-border bg-sky-50 dark:bg-sky-950 text-foreground shadow-lg overflow-hidden">
      <div className="flex items-center gap-3 px-4 py-3">
        <LoaderCircle className="h-5 w-5 animate-spin text-[var(--brand-teal)] shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium">
            {isSingle ? "Exporting entry..." : `Exporting entries... ${current} / ${total}`}
          </p>
        </div>
      </div>
      <ProgressBar value={isSingle ? 65 : pct} weighted={!isSingle} />
    </div>
  );
}
